/**
 * Modes de signature côté UI, choisis par le client et le partenaire. Ils sont utilisés pour déterminer
 */
export const SIGNATURE_MODE = {
    MANUAL: 'manual',
    ELECTRONIC: 'universign',
    NONE: 'no',
};

export const isManualMode = (mode) => SIGNATURE_MODE.MANUAL === mode;

export const isElectronicMode = (mode) => SIGNATURE_MODE.ELECTRONIC === mode;

export const isNoSignMode = (mode) => SIGNATURE_MODE.NONE === mode;
